<template>
  <div class="play-all-menu">
    <div class="table-header">
      <span>选集</span>
      <span @click="mclose">x</span>
    </div>
    <div class="desc">VIP会员子腾学堂全场免费观看</div>
    <div :swipeable="true" class="table-content">
      <div class="menu">
        <template v-for="(item, key) in videos">
          <div :key="key" @click="clickHandle(key)" :class="['item', item.id == videoInfo.id?'play':'']">
            <div class="item-title">
              <lottie v-if="item.id == videoInfo.id" class="play-directive" :options="animOptions" :height="20" :width="20" />
              <span>第{{ key+1 }}集</span>
              <template v-if="item.tryseetime == 0">
                <span class="vip-tag">{{ paytag }}</span>
              </template>
            </div>
            <div class="item-content">
              {{ substring(albumType == 0 ? item.videoname : item.track_title, 7, true) }}
            </div>
          </div>
        </template>
        <!-- 占位填充无任何实际意义 -->
        <div class="item item-end"></div>
        <div class="item item-end"></div>
        <div class="item item-end"></div>
        <div class="item item-end"></div>
        <div class="item item-end"></div>
        <div class="item item-end"></div>
        <div class="item item-end"></div>
        <div class="item item-end"></div>
        <div class="item item-end"></div>
        <div class="item item-end"></div>
      </div>
    </div>
  </div>
</template>

<script>
import lottie from 'vue-lottie';
import * as playAnimation from "@/assets/animation-icon/play.json";
import { substring } from '@/utils/index'
export default {
  name: 'PlayAllMenu',
  components: {
    lottie
  },
  props: {
    albumType: { // 专辑类型 0 视频 1 音频
      type: Number,
      default: 0
    },
    videos: {
      type: Array,
      default: function() {
        return []
      }
    },
    videoInfo: {
      type: Object,
      default: function() {
        return {}
      }
    },
    isPay: {
      type: Boolean,
      default: false
    },
    paytag: {
      type: String,
      default: 'VIP'
    }
  },
  data () {
    return {
      activeTab: 'menu',
      animOptions: { animationData: playAnimation }
    }
  },
  methods: {
    clickHandle(key){
      this.$emit('click', key)
    },
    mclose() {
      this.$emit('close')
    },
    substring
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.play-all-menu{
  background-color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  .table-header{
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    padding: 16px;
    color: #333;
    font-weight: 600;
  }
  .desc{
    color: #666;
    font-size: 12px;
    text-align: left;
    padding-left: 16px;
    margin-bottom: 16px;
  }
  .table-content{
    text-align: left;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    flex: 1;
    .menu{
      padding: 0 10px;
      display: flex;
      flex-wrap: wrap;
      // justify-content: space-around;
      // gap: 0 0.5rem;
      .item{
        flex-basis: 100px;
        flex-shrink: 0;

        font-size: 16px;
        padding: 6px;
        align-items: center;
        border: 1px solid #FFEDD4;
        border-radius: 8px;
        margin: auto;
        margin-bottom: 8px;
        &.item-end{
          border: none;
          padding: 0 6px;
        }
        .item-title{
          color: #333;
          margin-bottom: 4px;
          position: relative;
          .vip-tag{
            position: absolute;
            top: -7px;
            right: -7px;
            background: linear-gradient(90deg, #F7DDB8 0%, #F3BB6F 100%);
            border-radius: 0px 8px 0px 8px;
            padding: 1px 6px;
            font-size: 12px;
          }
        }
        .item-content{
          color: #666666;
          font-size: 12px;
        }
        .play-directive{
          margin-right: 3px;
          display: inline-block;
          width: 16px;
          height: 16px;
          vertical-align: middle;
        }

      }
      .play{
        border-color: #FF6767;
        .item-title{
          color: #FF6767;
          .vip-tag{
            color: #fff;
            background: #FF6767;
          }
        }
        .item-content{
          color: #FF6767;
        }
      }
    }
  }
}

@media screen and (max-width: 320px) {
  .play-all-menu{
    .table-content{
      .menu{
        .item{
          flex-basis: 150px;
        }
      }
    }
  }
}
</style>